import myHeader from "../../components/header.vue"
import myFooter from "../../components/footer.vue"
import {
  formatDate
} from '@/api/common.js'
import pdf from 'vue-pdf'
import {
  getListSelect,
  realNameAuthentication,
  getEmployeeInformation,
  getEnterpriseEmployeeDict,
  updateEmployeeInformation,
  enterpriseEmployeeModifyPassword,
  employeeSendMobile,
  employeePasswordVerification,
  employeeMobileVerification,
  getTrainingRecordPackagebagList,
  selectActivationCodeEmpList,
  getActiveList,
  getTrainingRecord,
  getPrintTrainingRecord,
  exerciseCollectList,
  exerciseDetailVerification,
  exerciseDetails,
  exerciseCollect,
  getUnderlineRegisterCourseList,
  getEmployeeStudyList
} from "@/apiCloud/userCenter";
import {mapGetters} from 'vuex'

export default {
  components: {
    myHeader,
    myFooter,
    pdf
  },
  data() {
    var oldPwd = (rule, value, callback) => {
      if (value === '') {
        callback(new Error('请输入密码'));
      } else {
        if (this.pwdForm.oldPassword !== '') {
          this.$refs.pwdForm.validateField('oldPassword');
        }
        callback();
      }
    };
    var validatePass = (rule, value, callback) => {
      if (value === '') {
        callback(new Error('请输入密码'));
      } else if (this.pwdForm.newPassword !== '' && this.pwdForm.newPassword.length >= 6) {
        this.$refs.pwdForm.validateField('newPassword');
      } else {
        callback(new Error('密码至少六位'))
      }

    };
    var validatePass2 = (rule, value, callback) => {
      if (value === '') {
        callback(new Error('请再次输入密码'));
      } else if (value !== this.pwdForm.newPassword) {
        callback(new Error('两次输入密码不一致!'));
      } else {
        callback();
      }
    };
    var valiIcon = (rule, value, callback) => { // 图片验证
      if (!this.dataInfo.empIdcardFront) {
        callback(new Error('请上传身份证人像面'));
      } else {
        callback();
      }
    };
    var valiIcon2 = (rule, value, callback) => { // 图片验证
      if (!this.dataInfo.empIdcardNegative) {
        callback(new Error('请上传身份证国徽面'));
      } else {
        callback();
      }
    };
    var valiIcon3 = (rule, value, callback) => { // 图片验证
      if (!this.dataInfo.empHeadportrait) {
        callback(new Error('请上传登记照'));
      } else {
        callback();
      }
    }
    return {
      detailDialog: false,
      imgInfo: {}, // 照片
      photoInfo: [], // table数据
      dataInfo: {},
      realRules: {
        name1: [{
          required: true,
          message: "请输入活动名称",
          trigger: "blur"
        }],
        name2: [{
          required: true,
          message: "请输入姓名",
          trigger: "blur"
        }],
        empIdcardFront: [{
          required: true,
          // message: "请上传身份证人像面",
          validator: valiIcon,
          trigger: "change"
        }],
        empIdcardNegative: [{
          required: true,
          // message: "请上传身份证国徽面",
          validator: valiIcon2,
          trigger: "change"
        }],
        empHeadportrait: [{
          required: true,
          // message: "请上传登记照",
          validator: valiIcon3,
          trigger: "change"
        }],
      },

      active: 1,
      show: 0,
      success: false,
      headerBase64: '',
      dialogVisible2: false,
      previewAvatar: '',
      buttonText: '下一步',
      action: process.env.VUE_APP_BASE_API + "/system/common/uploadImage",
      empTel: '',
      empPoliticaloutlookList: [],
      empCulturedegreeList: [],
      activeName: "one",
      loading: false, //上传头像的loading
      frontLoading: false, //身份证正面loading
      backLoading: false, //身份证反面loading
      headLoading: false, //登记照loading
      ruleForm: {
        empHeadportrait: '', //头像
        empName: '', //姓名
        empNativeplace: '', //籍贯
        empAddress: '', //地址
        empMedicalhistory: '', //是否有重大病史
        empPoliticaloutlook: '', //政治面貌
        empCulturedegree: '', //文化程度
        empCulturedegreeName: '', //文化程度
        empLabourunion: '', //是否加入工会
        empUniontime: '', //加入工会时间
        empUrgentname: '', //紧急联系人姓名
        empUrgentcall: '', //紧急联系人电话
        empWorkinghours: '', //开始工作时间
        empJointime: '', //入职本公司时间
        empBirthdate: '', //出生日期
        empIdtype: '', //证件类型
        empNation: "", //民族
        empSex: '', //性别
        empIdcard: "", //证件编号   //员工身份证
        affiliatedEnterprise: '', //所属企业
        entpCreditNo: '', //统一信用代码

        // empPoliticaloutlookList:[],
        // empCulturedegreeList:[]
      },
      tableHeight: document.body.offsetHeight - 280,
      tableHeight1: document.body.offsetHeight - 280,
      printSrc: '11111',
      optionsComplete: [{
          value: '0',
          label: '未学习'
        },
        {
          value: '1',
          label: '已学完'
        },
        {
          value: '2',
          label: '学习中'
        },
        {
          value: '3',
          label: '未分课'
        },
        {
          value: '4',
          label: '已作废'
        },
      ],
      completeState: '',
      credentialName: '',
      optionsCredentialName: [],
      trainingShcoolName: '',
      courseName: '',
      optionsPrint: [{
        value: '1',
        label: '是'
      }, {
        value: '0',
        label: '否'
      }],
      printState: '',
      packagebagName: '',
      aa: '',
      entpName: '',
      // value:'',
      // input:'',
      rules: {
        activationCode: [{
          required: true,
          message: "请输入激活码",
          trigger: "blur"
        }],
        reNewPassword: [{
          validator: validatePass2,
          trigger: 'blur'
        }],
        oldPassword: [{
          validator: oldPwd,
          trigger: 'blur'
        }],
        empName: [{
          validator: validatePass,
          trigger: 'blur'
        }],
      },
      pwdForm: {
        oldPassword: '',
        newPassword: '',
        reNewPassword: ''
      },
      pwdRules: {
        newPassword: [{
          validator: validatePass,
          trigger: 'blur'
        }],
        reNewPassword: [{
          validator: validatePass2,
          trigger: 'blur'
        }],
        oldPassword: [{
          validator: oldPwd,
          trigger: 'blur'
        }]
      },
      phoneForm: {
        password: '',
        newPhone: '',
        securityCode: '',
        verifySecurityCode: '',
      },
      phoneRules: {},
      trainRecordList: [],
      activationCodeList: [],
      myCredentialList: [],
      printRecordLi: null,
      pageNo: 1,
      pageSize: 10,
      count: 0,
      recordPageNo: 1,
      codePageNo: 1,
      recordPageSize: 10,
      codePageSize: 10,
      recordCount: 0,
      codeCount: 0,
      printHtml: '',

      collectPageNo: 1,
      collectCount: 0,
      collectPageSize: 12,
      exerciseCollectList: [],

      applyPageNo: 1,
      applyPageSize: 16,
      applyCount: 0,
      applyList: [],

      // radio:1,
      dialogVisible: false,
      dialogVisible1: false,
      zhenshu: false,
      orderPackagebagName: '',
      trainDetailShow: false,
      trainDetailList: [],
      lastStudyTime: '',
      recordDetailPageNo: 1,
      recordDetailCount: 0,
      TrainformData: {},
      formData: {},
      recordDetailPageSize: 10,
      empId: '',
      oneTrainRecordList: [],
      isJx: false,
      print: '',
      statbagId: "",
      courserActiveName: "toBe",
      classCodeShow: false,
      unitTypeOptions: [],
      queryForm: {},
      activationCode: null,
      isDisabled: false,
      personalIdentityCardVisible: false,
      dialogFormVisible: false, //证书
      contentHeight: {
        height: ''
      },
    }
  },
  computed:{
    ...mapGetters(['entpType'])
  },
  beforeMount() {

  },
  created() {
    this.getEmployeeDetail()
    this.autoHeight()
    if (localStorage.getItem("isJx") == "true") { // 是否是江西代理商访问
      this.isJx = true;
    }
    this.getActivationCodeEmpList();
    this.getActivationCode();

  },
  mounted() {
    this.setSmallHeight()
    var publicCourse = document.getElementById("notice");
    console.log(publicCourse)
    // publicCourse.style.minHeight = document.body.scrollHeight - 90 - 257 + "px"
  },
  methods: {
    autoHeight() {
      this.contentHeight.height = window.innerHeight - 150 + 'px'
    },
    // 获取激活码下拉
    getActivationCode() {
      let data = {}
      getListSelect(data).then(res => {
        if (res.code == 200) {
          this.unitTypeOptions = res.data
        } else {
          this.$message.error(res.message);
        }
      })
    },
    /* 实名认证上传 */
    beforeAvatarUpload(file) {
      const isLt2M = file.size / 1024 / 1024 < 2;
      if (!isLt2M) {
        this.$message.warning({
          duration: 1000,
          message: "上传图片大小不能超过 2MB！",
        });
      }
      return isLt2M;
    },
    handleProgress(event, file, fileList) {
      this.frontLoading = true;
    },
    backProgress(event, file, fileList) {
      this.backLoading = true;
    },
    headProgress(event, file, fileList) {
      this.headLoading = true;
    },
    // 获取上传图片路径
    frontSuccess(res, file, fileList) {
      console.log(res, 'res')
      this.$refs.empIdcardFront.clearValidate();
      this.dataInfo.empIdcardFront = res.msg;
      this.frontLoading = false;
    },
    backSuccess(res, file, fileList) {
      this.$refs.empIdcardNegative.clearValidate();
      this.dataInfo.empIdcardNegative = res.msg;
      this.backLoading = false;
    },
    headSuccess(res, file, fileList) {
      this.$refs.empHeadportrait.clearValidate();
      this.dataInfo.empHeadportrait = res.msg;
      this.headLoading = false;
    },
    // 实名认证保存
    saveRealname(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          var data = {
            empIdcardFront: this.dataInfo.empIdcardFront,
            empIdcardNegative: this.dataInfo.empIdcardNegative,
            empHeadportrait: this.dataInfo.empHeadportrait
          }
          realNameAuthentication(data).then(res => {
            if (res.code == 200) {
              this.$message.success({
                duration: 1000,
                message: '上传成功!',
              });
            } else {
              this.$message.error({
                duration: 1000,
                message: res.message,
              });
            }
          })
        } else {
          return false;
        }
      })
    },

    //获取个人信息
    getEmployeeDetail() {
      let data = {}
      getEmployeeInformation(data).then(res => {
        // console.log("人员信息", res)
        let data = res.data
        if (res.code == 200) {
          this.ruleForm = res.data
          this.dataInfo = res.data;
          this.empTel = res.data.empTel
          getEnterpriseEmployeeDict().then(result => {
            if (result.code == 200) {
              // console.log("字典",result)
              let temp = result.data;
              for (var i = 1; i < temp.length; i++) {
                let item = temp[i];
                if (item.dictCode == "POLITICAL_OUTLOOK") { //政治面貌
                  this.empPoliticaloutlookList = item.dictList;
                  item.dictList.forEach(items => {
                    if (items.dictId == this.ruleForm.empPoliticaloutlook) {
                      this.ruleForm.empPoliticaloutlookName = item.dictName
                    }
                  })
                }
                if (item.dictCode == "DEGREE_EDUCATION") { //文化程度
                  this.empCulturedegreeList = item.dictList
                  item.dictList.forEach(item => {
                    if (item.dictId == this.ruleForm.empCulturedegree) {
                      this.ruleForm.empCulturedegreeName = item.dictName
                    }
                  })

                }

              }
            }
          });
          if (!res.data.empHeadportrait) {
            // this.ruleForm.empHeadportrait = "../../../static/empHeadportrait.png"
          }
        }
      })
    },
    // 个人信息提交
    submitForm() {
      this.$confirm('是否修改个人信息?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        // let data = this.ruleForm
        let {
          empHeadportrait,
          empNativeplace,
          empAddress,
          empMedicalhistory,
          empPoliticaloutlook,
          empCulturedegree,
          empLabourunion,
          empUniontime,
          empUrgentname,
          empUrgentcall,
          empBirthdate,
          empNation,
          empSex,
          empIdcard
        } = this.ruleForm
        // console.log(999999,this.ruleForm.empPoliticaloutlook)
        let data1 = {
          empHeadportrait,
          empNativeplace,
          empAddress,
          empMedicalhistory,
          empPoliticaloutlook,
          empCulturedegree,
          empLabourunion,
          empUniontime,
          empUrgentname,
          empUrgentcall,
          empBirthdate,
          empNation,
          empSex,
          empIdcard
        };
        this.empPoliticaloutlookList.forEach(item => {
          if (item.dictName == this.ruleForm.empPoliticaloutlookName) {
            data1.empPoliticaloutlook = item.dictId
          }
        });
        //文化程度
        this.empCulturedegreeList.forEach(item => {
          if (item.dictName == this.ruleForm.empCulturedegreeName) {
            data1.empCulturedegree = item.dictId
          }
        });

        updateEmployeeInformation(data1).then(res => {
          if (res.code == 200) {
            this.getEmployeeDetail();
            localStorage.setItem("empHeadportrait", data1.empHeadportrait);
            this.$message({
              message: '修改成功',
              type: 'success'
            });
            location.reload();
          }
        })
      }).catch(() => {
        // this.$nextTick(() => {
        //   this.$refs['ruleForm'].resetFields()
        //   this.dialogVisible = false
        // })
        this.getEmployeeDetail()
        this.$message({
          type: 'info',
          message: '取消修改',
          duration: 1000
        });
      })
    },
    // 个人信息重置
    resetForm(formName) {
      this.$nextTick(() => {
        this.$refs[formName].resetFields()
        this.dialogVisible = false
        this.getEmployeeDetail()
      })
    },
    cancelMakeSure() {

    },
    changePassword() {
      this.dialogVisible = true
    },
    changePhone() {
      this.dialogVisible1 = true
      this.$refs['phoneForm'].resetFields();
    },

    closeDialog() {
      // 点击关闭 数据重置
      this.$refs['pwdForm'].resetFields();
    },
    submitPwdForm() {
      if (!this.pwdForm.newPassword) {
        return this.$message.error('请输入新密码')
      }
      if (!this.pwdForm.reNewPassword) {
        return this.$message.error('请输入确认新密码')
      }
      if (this.pwdForm.newPassword != this.pwdForm.reNewPassword) {
        return this.$message.error('两次输入密码不一致')
      }
      let data = {
        oldPassword: this.pwdForm.oldPassword,
        newPassword: this.pwdForm.newPassword
      }
      enterpriseEmployeeModifyPassword(data).then(res => {
        // console.log("修改密码", res)
        if (res.code == 200) {
          this.$message({
            message: '密码修改成功',
            type: 'success'
          })
          this.dialogVisible = false
        } else {
          this.$message.error(res.message);
        }
      })

    },
    cancelPwdForm(formName) {
      this.active = 1
      this.phoneForm.securityCode = ''
      this.phoneForm.newPhone = ''
      this.phoneForm.verifySecurityCode = ''

      this.$nextTick(() => {
        this.$refs[formName].resetFields()
        this.dialogVisible = false
      })
    },
    closePhoneDialog() {
      this.active = 1;
      this.$refs['phoneForm'].resetFields();
      // this.show=1
      this.success = false;
      // this.show=1
      this.buttonText = "下一步"
    },
    // submitPhoneForm(formName) { },
    cancelPhoneForm(formName) {
      this.$nextTick(() => {
        this.$refs[formName].resetFields();
        this.dialogVisible1 = false;
        this.success = false;
        this.show = 1;
        this.buttonText = "下一步"
      })
    },
    //验证码定时器
    getSecurityCode() {
      var element = $(".verfierButton")[0];
      var num = 60;
      var timer = setInterval(function () {
        num--
        element.innerHTML = num + '秒后重新获取';
        element.style.color = ' #ccc';
        element.disabled = ' disabled'
        if (num === 0) {
          element.disabled = ''
          element.style.color = ' #ffa600'
          element.innerHTML = '获取验证码'
          clearInterval(timer)
        }
      }, 1000)
      let data = {
        empTel: this.phoneForm.newPhone
      }
      employeeSendMobile(data).then(res => {
        console.log("获取验证码", res)
        this.phoneForm.securityCode = res.data
        if (res.code != 0) {
          this.$message.error('验证码获取失败');
        }
      })

    },
    next() {
      if (this.active == 1) {
        if (!this.phoneForm.password) {
          this.$message({
            message: '密码不能为空',
            type: 'warning',
            duration: '1000'
          });
        } else {
          let data = {
            oldPassword: this.phoneForm.password
          }
          employeePasswordVerification(data).then(res => {
            if (res.code == 200) {
              this.active++
              this.phoneForm.newPhone = ''
              this.phoneForm.password = ''
            } else {
              this.active = 1
              this.$message.error('密码错误');
            }
          })
        }

      } else if (this.active == 2) {
        let data = {
          empTel: this.phoneForm.newPhone,
          mobileCode: this.phoneForm.securityCode
        }
        employeeMobileVerification(data).then(res => {
          if (res.code == 200) {
            this.dialogVisible1 = false
            this.phoneForm.securityCode = ''
            this.phoneForm.newPhone = ''
            this.phoneForm.verifySecurityCode = ''

            this.$message({
              message: '手机号修改成功！',
              type: 'success',
              duration: '1000'

            });
            localStorage.setItem("empTel", this.phoneForm.newPhone)
            getEmployeeInformation().then(res => {
              if (res.code == 200) {
                let data = res.data
                this.empTel = res.data.empTel
                // console.log(empTel)
              }
            })
          } else {
            this.active = 2
            this.$message.error(res.message);
          }
        })
      }
      // if (this.active++ > 2) this.active = 0;
    },
    //修改头像
    uploadSuccess(res, file, fileList) {
      this.ruleForm.empHeadportrait = res.data
      this.loading = false
    },
    uploadProgress() {
      this.loading = true
    },
    // 培训记录
    getTrainingRecord() {
      let data = {
        overStatus: this.completeState,
        orderPackagebagName: this.orderPackagebagName,
        trainingShcoolName: this.trainingShcoolName,
        empId: this.empId,
        pageSize: this.recordPageSize,
        pageNum: this.recordPageNo

      }
      getTrainingRecordPackagebagList(data).then(res => {
        if (res.code == 200) {
          let data = res.rows
          data.map(((item, index) => {
            switch (item.overStatus) {
              case "0":
                item['compState'] = "未学习";
                break;
              case "1":
                item['compState'] = "已学完";
                break;
              case "2":
                item['compState'] = "学习中";
                break;
            }
          }))
          this.trainRecordList = data

          this.recordCount = res.total
        }
      })
    },

    //激活码查询
    codeCheck() {
      this.getActivationCodeEmpList();
    },
    // 激活码列表
    getActivationCodeEmpList() {
      let data = {
        pageSize: this.codePageSize,
        pageNum: this.codePageNo
      }
      for (var i in this.queryForm) {
        data[i] = this.queryForm[i]
      }
      selectActivationCodeEmpList(data).then(res => {
        if (res.code == 200) {
          let data = res.rows
          // data.map(((item, index) => {
          //   switch (item.overStatus) {
          //     case "0":
          //       item['compState'] = "未学习";
          //       break;
          //     case "1":
          //       item['compState'] = "已学完";
          //       break;
          //     case "2":
          //       item['compState'] = "学习中";
          //       break;
          //   }
          // }))
          this.activationCodeList = data
          this.codeCount = res.total
        }
      })
    },
    change() {
      this.$forceUpdate()
    },
    // 激活课程弹窗
    classCode() {
      if (this.activationCode != null) {
        this.formData.activationCode = this.activationCode.activationCode
      }
      this.classCodeShow = true;
    },
    // 激活课程
    determineActivation(formName) {
      let data = {
        activationCode: this.formData.activationCode
      }
      this.$refs[formName].validate((valid) => {
        if (valid) {
          this.isDisabled = true
          setTimeout(() => {
            this.isDisabled = false //点击一次时隔两秒后才能再次点击
          }, 2000)
          getActiveList(data).then(res => {
            if (res.code == 200) {
              this.$message({
                message: res.msg,
                type: 'success'
              });
              this.formData.activationCode = ''
              this.classCodeShow = false;
              this.getActivationCodeEmpList();
            } else {
              this.isDisabled = true
              setTimeout(() => {
                this.isDisabled = false //点击一次时隔两秒后才能再次点击
              }, 2000)
              this.$message.error(res.msg);
            }
          })
        }
      })

    },
    //关闭激活课程弹窗
    closeCodeShow() {
      this.formData = {};
      this.classCodeShow = false;
    },
    checkTrainDetail(row) {
      this.trainDetailShow = true
      this.empId = row.empId
      this.statbagId = row.statbagId;
      this.packagebagId = row.packagebagId
      let data = {
        packagebagId: row.packagebagId,
        empId: row.empId,
        statbagId: row.statbagId,
        pageSize: 10,
        pageNum: 1

      }
      getTrainingRecord(data).then(res => {
        if (res.code == 200) {
          this.oneTrainRecordList = res.data
          this.recordDetailCount = res.total
          this.oneTrainRecordList.forEach(item => {
            switch (item.state) {
              case "0":
                item['compState'] = "未学习";
                break;
              case "1":
                item['compState'] = "已学完";
                break;
              case "2":
                item['compState'] = "学习中";
                break;
            }
          })
        }
      })
    },
    //培训详情
    onSearchTrainDetail() {
      this.recordDetailPageNo = 1
      this.getTrainingRecordList()
    },
    getTrainingRecordList() {
      let data = {
        state: this.TrainformData.completeStateDetail,
        courseName: this.TrainformData.courseName,
        packagebagId: this.packagebagId,
        empId: this.empId,
        statbagId: this.statbagId,
        pageSize: this.recordDetailPageSize,
        pageNum: this.recordDetailPageNo

      }
      getTrainingRecord(data).then(res => {
        if (res.code == 200) {
          this.oneTrainRecordList = res.data
          this.recordDetailCount = res.total;
          this.oneTrainRecordList.forEach(item => {
            switch (item.state) {
              case "0":
                item['compState'] = "未学习";
                break;
              case "1":
                item['compState'] = "已学完";
                break;
              case "2":
                item['compState'] = "学习中";
                break;
            }
          })
        }
      })
    },
    recordSelectionChange(list) {
      // console.log("111",list)
    },
    codeSelectionChange(list) {
      this.activationCode = list
    },
    recordDetailCurrentChange(page) {
      this.recordDetailPageNo = page
      this.getTrainingRecordList()
    },
    recordCurrentChange(page) {
      // console.log(page)
      this.recordPageNo = page
      this.getTrainingRecord()
    },
    trainDetailClose() {
      this.trainDetailShow = false
      // this.getTrainingRecord()
    },
    //我的证书
    getPrintTrainingRecord(search) {
      let data = {
        // printState:this.printState,
        packagebagName: this.packagebagName,
        pageSize: this.pageSize,
        pageNum: this.pageNo
      };
      getPrintTrainingRecord(data).then(res => {
        if (res.code == 200) {
          let data = res.rows;
          if (!search) {
            this.optionsCredentialName = [];
            data.map(((item, index) => {
              item['index'] = index;
              if (item.state == 0) {
                item['compState'] = "否"
              } else {
                item['compState'] = "是"
              }
              if (item.printState == 0) {
                item['isPrint'] = "否"
              } else {
                item['isPrint'] = "是"
              }
              this.optionsCredentialName.push({
                "value": item.packagebagName,
                "label": item.packagebagName
              })

            }))
          }
          this.myCredentialList = data;
          this.count = res.total;
          this.printRecordLi = null
        }
      })
    },

    //打印id
    selectionChange(list) {
      this.printRecordLi = list
    },
    currentChange(page) {
      this.pageNum = page;
      this.getPrintTrainingRecord()
    },
    printRecord() {
      if (this.printRecordLi == null) {
        this.$message({
          message: '请选择需要打印的证书',
          type: 'warning'
        });
        return false
      }
      if (this.printRecordLi) {
        let packagebagId = this.printRecordLi.packagebagId
        let finishedTime = this.printRecordLi.packageFishedTime ? this.printRecordLi.packageFishedTime : ''
        let certificationId = this.printRecordLi.certificationId
        let empId = this.printRecordLi.empId
        let data = {
          packagebagId: packagebagId,
          finishedTime: finishedTime,
          certificationId: certificationId,
          empId: empId,
          tokenId: localStorage.getItem("tokenId"),
          entpId: localStorage.getItem("enterpriseId")
        }
        this.printSrc = '/prod-api/eceping-stat/certification/getValidityCertificationResult?certificationId=' +
          this.printRecordLi.certificationId
        // newWindow.location = this.printSrc
        this.dialogFormVisible = true;
        // newWindow.write("<title>证书打印</title>")
        // this.getPrintTrainingRecord()


        //  if(certificationId){
        //   this.printSrc=courseURL+url1+'?packagebagId='+packagebagId+"&finishedTime="+finishedTime+"&certificationId="+certificationId+"&empId="+empId+"&tokenId="+localStorage.getItem("tokenId")+"&entpId="+localStorage.getItem("enterpriseId")
        //   let newWindow = window.open("", "_blank")
        //   newWindow.location =this.printSrc
        //   // newWindow.write("<title>证书打印</title>")
        //   this.getPrintTrainingRecord()
        //  }else{
        //   let newWindow = window.open("", "_blank")
        //   getCourseList(url,data).then(res=>{
        //     if(res.code==0){
        //       if(res.data.certificationId){
        //         this.printSrc=courseURL+url1+'?packagebagId='+packagebagId+"&finishedTime="+finishedTime+"&certificationId="+res.data.certificationId+"&empId="+empId+"&tokenId="+localStorage.getItem("tokenId")+"&entpId="+localStorage.getItem("enterpriseId")
        //         newWindow.location =this.printSrc
        //         // newWindow.write("<title>证书打印</title>")
        //       }
        //       this.getPrintTrainingRecord()
        //       this.myCredentialList.map((item,index)=>{
        //         if(index==temp){
        //           console.log(item)
        //           item.certificationId=res.data.certificationId
        //           item['certificationNo']=res.data.certificationNo
        //           console.log(item)
        //         }
        //       })
        //     }
        //   })
        //  }

      } else {
        this.$message({
          message: '请选择需要打印的证书',
          type: 'warning'
        })
      }
    },
    //我的收藏
    getExerciseCollectList() {
      if ($('#box2') != undefined && $('#box2').offset() != undefined && $('#box2').offset().top != undefined) {
        $('html,body').animate({
          scrollTop: '0px'
        }, 500)
      }
      let data = {
        pageSize: this.collectPageSize,
        pageNum: this.collectPageNo
      }
      exerciseCollectList(data).then(res => {
        if (res.code == 200) {
          this.exerciseCollectList = res.rows
          this.collectCount = res.total
        }
      })
    },
    goToExamDetail(examId, courseId) {
      let data1 = {
        exerciseId: examId,
        courseId: courseId
      };
      exerciseDetailVerification(data1).then(res => {
        if (res.code == 200) {
          let data = {
            exerciseId: examId
          };
          exerciseDetails(data).then(res => {
            if (res.code == 200) {
              this.$router.push({
                path: "/examDetail",
                query: {
                  exerciseId: examId,
                  courseId: courseId
                }
              });
            } else {
              this.$alert(res.message, '提示', {
                confirmButtonText: '确定',
                callback: action => {

                }
              });
            }
          })
        } else {
          this.$alert(res.message, '提示', {
            confirmButtonText: '确定',
            callback: action => {

            }
          });
        }
      })

    },
    /*收藏、取消收藏 */
    cancelCollect(exerciseId, collectType, index) {
      if (collectType == 0) {
        this.exerciseCollectList[index].collectType = 1
        this.exerciseCollect(exerciseId, 1)
      } else if (collectType == 1) {
        this.exerciseCollectList[index].collectType = 0
        this.exerciseCollect(exerciseId, 0)
      }
    },
    exerciseCollect(exerciseId, collectType) {
      let data = {
        collectType,
        exerciseId,
      }
      exerciseCollect(data).then(res => {
        if (res.code == 200) {

        }
      })
    },
    collectCurrentChange(page) {
      this.collectPageNo = page
      this.getExerciseCollectList()
    },

    applyCurrentChange(val) {
      this.applyPageNo = val
      this.getMyApplyList()
    },
    //我的报名
    getMyApplyList() {
      if ($('#box4') != undefined && $('#box4').offset() != undefined && $('#box4').offset().top != undefined) {
        $('html,body').animate({
          scrollTop: '0px'
        }, 500)
      }
      let data = {
        pageSize: this.applyPageSize,
        pageNum: this.applyPageNo
      }
      getUnderlineRegisterCourseList().then(res => {
        this.applyList = res.rows
        this.applyCount = res.total
      })
    },
    GotoOfflineCourseDetail(courseId) {
      // console.log(1111)
      this.$router.push({
        path: "/offlineCourseDetail",
        query: {
          courseId
        }
      });
    },
    //设置最小高度
    setSmallHeight() {
      let clientHeight = document.body.clientHeight
      let height = clientHeight - 90
      if ($("#box3").height() < height) {
        $("#box3").height(height - 50)
      }
    },
    //tab切换
    handleClickTab(tab, event) {
      this.printState = ""
      this.packagebagName = ""
      this.completeState = ""
      this.courseName = ""
      this.trainingShcoolName = ""
      this.entpName = ""
      this.recordPageSize = 10
      this.recordPageNo = 1
      this.pageSize = 10
      this.pageNo = 1
      this.printRecordLi = null
      $('html,body').animate({
        scrollTop: '0px'
      }, 500)
      if (this.activeName == "one") {
        this.getEmployeeDetail()
      } else if (this.activeName == "two") {
        this.getTrainingRecord()
      } else if (this.activeName == "three") {
        this.getPrintTrainingRecord()
      } else if (this.activeName == "four") {
        this.getExerciseCollectList()
        // let clientHeight=document.body.clientHeight
        // let height=clientHeight -120
        // if ($("#box2").height()+600<height) {
        //     $("#box2").height(height)
        //     console.log(1111)
        //   }

      } else if (this.activeName == "five") {
        this.getMyApplyList()
      } else if (this.activeName == "six") {
        this.getActivationCodeEmpList()
      } else if (this.activeName == 'realName') {
        if (this.dataInfo.empHeadportrait == null ||
          this.dataInfo.empHeadportrait == '' ||
          this.dataInfo.empHeadportrait == '../../../static/empHeadportrait.png') {
          this.personalIdentityCardVisible = true
        }
      }
    },
    //时间转换
    formatDate(time) {
      var date = new Date(time);
      return formatDate(date, 'yyyy-MM-dd hh:mm:ss');
    },

    // 查看学习照片
    checkPhoto(row) {
      // console.log(row, "row");
      this.courseId = row.courseId;
      this.detailDialog = true;
      this.getCards();
    },
    // 获取身份证正反面头像
    getCards() {
      getTrainingRecordPackagebagList().then(res => {
        if (res.code == 200) {
          this.imgInfo = res.data[0];
          this.regId = res.data[0].regId;
          this.getStudyList();
        }
      })
    },
    // 获取学习信息(章节)
    getStudyList() {
      var params = {
        courseId: this.courseId,
        empId: this.empId,
        regId: this.regId,
      }
      getEmployeeStudyList(params).then(res => {
        if (res.code == 200) {

          this.photoInfo = res.data;
          this.photoInfo.sectionName
          for (let i = 0; i < this.photoInfo.length; i++) {
            this.photoInfo[i].sectionName = this.photoInfo[i].cateName + "——" + this.photoInfo[i].ccName
            this.photoInfo[i].state = this.photoInfo[i].invalid === 0 ? "通过" : this.photoInfo[i].invalid === 1 ? "不通过" : "待审核";
            this.photoInfo[i].courseOver = this.photoInfo[i].courseOver === 0 ? "学习中" : this.photoInfo[i].courseOver === 1 ? "已学完" : "待学习";
          }
          // this.photoInfo = res.data.map(item => {
          // var invalid = item.invalid;
          // item.state =
          //   invalid === 0 ? "通过" : invalid === 1 ? "不通过" : "待审核";
          // var invalidComment = item.invalidComment;
          // var cateName = item.cateName;
          // var ccName = item.ccName;
          // var photoList = item.photoList;
          // item.sectionName = cateName + "——" + ccName;
          // if (photoList.length) {
          // item.photoUrl = photoList[0].photoUrl;
          // item.createdate = photoList[0].createdate;
          // }
          // return item;
          // });
          console.log("this.photoInfo", this.photoInfo)
        }
      })
    }
  }
}



// WEBPACK FOOTER //
// ./src/pages/userCenter/userCenter.js